var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _g5, _path7, _g6, _path8, _path9, _g7, _path10, _g8, _path11, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 0V23.9292H11.8259L19.5032 10.6352H39.0064V0H3.09393Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 0V23.9292H11.8259L19.5032 10.6352H39.0064V0H3.09393Z",
    fill: "url(#paint0_linear_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0369 23.8525L3.20896 8.7178L3.08112 8.9415L11.8451 23.9612L12.0369 23.8525Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9936H18.5635L27.1805 30.3781V23.9228H11.8259L0 3.64946V38.9936Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9936H18.5635L27.1805 30.3781V23.9228H11.8259L0 3.64946V38.9936Z",
    fill: "url(#paint1_linear_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0015 24.2232L26.8161 24.1146L18.3078 38.9936H18.5635L27.0078 24.2296H27.0015V24.2232Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 28,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9936H18.5635L27.1805 30.3845V23.9292H11.8259L0 3.64946V38.9936Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352L27.1805 23.9292L18.5635 38.9936H39V10.6352H19.4968H19.5032Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352L27.1805 23.9292L18.5635 38.9936H39V10.6352H19.4968H19.5032Z",
    fill: "url(#paint2_linear_2_1141)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352L27.1805 23.9292L18.5635 38.9936H39V10.6352H19.4968H19.5032Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352L27.1805 23.9292L18.5635 38.9936H39V10.6352H19.4968H19.5032Z",
    fill: "url(#paint3_linear_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 21,
    height: 29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352L27.1805 23.9292L18.5635 38.9936H39V10.6352H19.5032Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 0V23.9292H11.8259L19.5032 10.6352H39.0064V0H3.09393Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 0V23.9292H11.8259L19.5032 10.6352H39.0064V0H3.09393Z",
    fill: "url(#paint4_linear_2_1141)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.6352V15.2753L36.8777 10.6352H19.5032Z",
    fill: "url(#paint5_radial_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 36,
    height: 24
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 0V8.9351L11.8259 23.9292L19.5032 10.6352H39V0H3.09393Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9936H18.5635L27.1805 30.3781V23.9228H11.8259L0 3.64946V38.9936Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9936H18.5635L27.1805 30.3781V23.9228H11.8259L0 3.64946V38.9936Z",
    fill: "url(#paint6_linear_2_1141)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09393 8.96066L15.7828 21.6411L11.8259 23.9228L3.09393 8.96066Z",
    fill: "url(#paint7_radial_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5763 38.9744L23.2236 21.6475L27.1805 23.9292L18.5763 38.9744Z",
    fill: "url(#paint8_radial_2_1141)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 28.3648C24.3999 28.3648 28.3695 24.3959 28.3695 19.5C28.3695 14.6041 24.3999 10.6352 19.5032 10.6352C14.6065 10.6352 10.637 14.6041 10.637 19.5C10.637 24.3959 14.6065 28.3648 19.5032 28.3648Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 26.588C23.4185 26.588 26.5924 23.4146 26.5924 19.5C26.5924 15.5854 23.4185 12.412 19.5032 12.412C15.588 12.412 12.4141 15.5854 12.4141 19.5C12.4141 23.4146 15.588 26.588 19.5032 26.588Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 10.4115C14.6066 10.4115 10.637 14.3805 10.637 19.2763V19.5C10.637 14.6042 14.6066 10.6352 19.5032 10.6352H39.0064V10.4115H19.5032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1677 23.9292C25.6335 26.5752 22.7761 28.3584 19.5032 28.3584C16.2303 28.3584 13.3665 26.5752 11.8323 23.9292H11.8259L0 3.64946V3.87316L11.8259 24.1529H11.8323C13.3665 26.7989 16.2239 28.5821 19.5032 28.5821C22.7825 28.5821 25.6399 26.7989 27.1677 24.1529H27.1805V23.9292H27.1677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.7205 10.6352C19.6822 10.6352 19.6502 10.6352 19.6119 10.6416C24.4573 10.6991 28.3631 14.6426 28.3631 19.5C28.3631 24.3574 24.4509 28.2945 19.6119 28.3584C19.6502 28.3584 19.6822 28.3648 19.7205 28.3648C24.6171 28.3648 28.5868 24.3958 28.5868 19.5C28.5868 14.6042 24.6171 10.6352 19.7205 10.6352Z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2572 24.2232C28.0115 22.9194 28.4462 21.411 28.4462 19.8004C28.4462 18.8672 28.2991 17.9661 28.0307 17.1224C28.2416 17.883 28.3631 18.6755 28.3631 19.5C28.3631 21.1106 27.9284 22.619 27.1741 23.9228L18.5571 39H18.8128L27.2508 24.236L27.2572 24.2232Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 39C30.2745 39 39.0064 30.2696 39.0064 19.5C39.0064 8.73045 30.2745 0 19.5032 0C8.73188 0 0 8.73045 0 19.5C0 30.2696 8.73188 39 19.5032 39Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 0.223697C30.236 0.223697 38.9425 8.89676 39 19.6087C39 19.5703 39 19.5383 39 19.5C39 8.73058 30.2744 0 19.5032 0C8.73201 0 0 8.73058 0 19.5C0 19.5383 0 19.5703 0 19.6087C0.0639239 8.89036 8.77037 0.223697 19.5032 0.223697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 38.7763C30.236 38.7763 38.9425 30.1033 39 19.3914C39 19.4297 39 19.4617 39 19.5C39 30.2694 30.268 39 19.4968 39C8.72562 39 0 30.2694 0 19.5C0 19.4617 0 19.4297 0 19.3914C0.0575316 30.1096 8.76397 38.7763 19.4968 38.7763H19.5032Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1141",
    x1: 4.65214,
    y1: 14.9843,
    x2: 16.2919,
    y2: 8.18527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1141",
    x1: 22.7234,
    y1: 34.7955,
    x2: 9.80535,
    y2: 27.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1141",
    x1: 25.1639,
    y1: 9.38762,
    x2: 28.4168,
    y2: 23.6411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1141",
    x1: 25.1639,
    y1: 9.38762,
    x2: 28.4168,
    y2: 23.6411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1141",
    x1: 4.65214,
    y1: 14.9843,
    x2: 16.2919,
    y2: 8.18527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4633 10.7626) scale(18.6329 18.6299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_1141",
    x1: 22.7234,
    y1: 34.7955,
    x2: 9.80535,
    y2: 27.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.89072 9.11648) scale(17.2965 17.2936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2768 19.6515) scale(19.4658 19.4626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.058f0e326ab4e66e2fc477e89787ba81.svg";
export { ForwardRef as ReactComponent };